import { ICONS } from "../../common/constants/icons";
import exportFromJSON from "export-from-json";

const GolbalExport = (props) => {
  return (
    <img src={ICONS.Export} alt="Export" />
  );
};

const handleExport1 = (filteredResult, filename, colName, Fieldname, tmpcolumnDefs) => {
  let data = [];
  for (const element of filteredResult) {
    let tmpdata = []
    for (let i = 0; i < colName.length; i++) {
      let tmpcol = colName[i]["headerName"];
      let tmpfield = colName[i]["field"];
      if (i == 0) {
        tmpdata.push({
          [tmpcol]: element[tmpfield]
        })
      }
      else {
        tmpdata = tmpdata.map(v => ({ ...v, [tmpcol]: element[tmpfield] }));
      }
    }
    data = [...data, ...tmpdata]
  }
  const fileName = filename;
  const exportType = "csv";

  exportFromJSON({ data, fileName, exportType });
};

const handleExportWPQ = (filteredResult, filename, colName) => {
  let data = [];
  for (const element of filteredResult) {
    //To add qulification due in excel
    const [year, month, day] = element.WPQ_Welder_ExpiresOn.split("-");
    const today = new Date();
    const future = new Date(year, month - 1, day);
    const timeDifferenceInMilliseconds = future - today;
    const daysDifference = Math.ceil(timeDifferenceInMilliseconds / (1000 * 60 * 60 * 24));
    element.wpq_QualificationDueIn = daysDifference < 0 ? "Inactive" : `${daysDifference} days`;

    /// till here
    let tmpdata = []

    for (let i = 0; i < colName.length; i++) {
      let tmpcol = colName[i]["headerName"];
      let tmpfield = colName[i]["field"];
      if (i == 0) {
        tmpdata.push({
          [tmpcol]: element[tmpfield]
        })
      }
      else {
        tmpdata = tmpdata.map(v => ({ ...v, [tmpcol]: element[tmpfield] }));
      }
    }
    data = [...data, ...tmpdata]
  }
  const fileName = filename;
  const exportType = "csv";
  exportFromJSON({ data, fileName, exportType });
};

export default GolbalExport;
export { handleExport1, handleExportWPQ };